import React from "react";
import { useParams } from "react-router-dom";
import { useProjectTimesheetList } from "../../hooks/useProjectTimesheetList";
import ProjectTimeSheetListView from "./ProjectTimeSheetListView";

function ProjectTimeSheetListContainer() {
    const { id } = useParams();
    const {
        timesheets,
        allTimesheets,
        filterStatus,
        setFilterStatus,
        filterUser,
        setFilterUser,
        sortOrder,
        setSortOrder,
        loading,
        error,
        handleApprove,
        handleReject,
        confirmDelete,
        handleDeleteConfirmed,
        showDeleteModal,
        setShowDeleteModal,
        auth
    } = useProjectTimesheetList(id);

    return (
        <ProjectTimeSheetListView
            timesheets={timesheets}
            allTimesheets={allTimesheets}
            filterStatus={filterStatus}
            setFilterStatus={setFilterStatus}
            filterUser={filterUser}
            setFilterUser={setFilterUser}
            sortOrder={sortOrder}
            setSortOrder={setSortOrder}
            loading={loading}
            error={error}
            handleApprove={handleApprove}
            handleReject={handleReject}
            confirmDelete={confirmDelete}
            handleDeleteConfirmed={handleDeleteConfirmed}
            showDeleteModal={showDeleteModal}
            setShowDeleteModal={setShowDeleteModal}
            auth={auth}
        />
    );
}

export default ProjectTimeSheetListContainer;

ProjectTimeSheetListContainer.propTypes = {
    // No props - uses useParams
};
